import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../../app.config';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss'],
})
export class CommunityComponent implements OnInit {
  public navigationItems: any = [
    {
      title: this.translate.instant('bikeshop.community.bikeshop_posts'),
      icon: 'hubtiger-posts',
      description: this.translate.instant(
        'bikeshop.community.bikeshop_posts_description',
      ),
      path: 'store/general-communication',
    },
    {
      title: this.translate.instant('bikeshop.community.bikeshop_rides'),
      icon: 'hubtiger-community',
      description: this.translate.instant(
        'bikeshop.community.bikeshop_rides_description',
      ),
      path: 'store/shop-rides',
      disabled: false,
    },
    {
      title: 'Bike Shop Forum',
      icon: 'hubtiger-forum',
      description:
        'Make your bike shop the heart of your local community - give them the ability to organise group rides, chat about new products, safety concerns and anything that is important to them.',
      path: 'store/community',
      disabled: true,
    },
  ];

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    var partner = this.helpersService.getPartnerData();
  }
}
